export default {
    show: false,
    showToastConfirm: false,
    message: null,
    timer: 7,
    icon: 'exclamation',
    theme: 'warning',
    callback: null
}
